import { Serializable } from '../../core/models/serializable';
export class LocationListViewModel
  implements Serializable<LocationListViewModel>
{
  fromObject(obj: any): LocationListViewModel {
    Object.assign(this, obj);

    return this;
  }
  toObject() {
    let result = {
      LocationId: this.locationId,
      Name: this.name,
      Type: this.type,
    };
    return result;
  }

  public locationId: string;

  public name: string;

  public type: LocationTypeEnum;
}

export class LocationsViewModel implements Serializable<LocationsViewModel> {
  fromObject(object: any): LocationsViewModel {
    Object.assign(this, object);

    this.locations = [];

    if (
      object.locations &&
      object.locations.length &&
      object.locations.length > 0
    ) {
      object.locations.forEach((el) => {
        let t = new LocationListViewModel();
        t = t.fromObject(el);
        this.locations.push(t);
      });
    }

    return this;
  }

  toObject() {
    throw new Error('Not Implemented');
  }

  public parentLocationId: string;
  public locations: LocationListViewModel[];

  constructor() {
    this.parentLocationId = null;
    this.locations = [];
  }
}

// export interface LocationListViewModel{
//     locationId: string;
//     name: string;
//     type: LocationTypeEnum;
// }

// export interface LocationsViewModel{
//     parentLocationId: string;
//     locations: LocationListViewModel[];
// }

export enum LocationStatusEnum {
  Active = 1,
  Inactive = 2,
}

export enum LocationTypeEnum {
  Root = 1,
  Undefined = 2,
  Other = 3,
  Country = 4,
  State = 5,
  City = 6,
  District = 7,
  Street = 8,
  Abroad = 9,
  Wildcard = 10,
}
